import React from 'react';
import { User, Cpu } from 'lucide-react';
import { copy } from '../../copy';
import { SlideOver } from './SlideOver';
interface AuditLogProps {
  open: boolean;
  onClose: () => void;
}
export function AuditLog({
  open,
  onClose
}: AuditLogProps) {
  const {
    auditLog,
    auditLogTitle
  } = copy.workflow;
  return <SlideOver open={open} onClose={onClose} title={auditLogTitle} subtitle={auditLog.subtitle} data-id="element-77">
      <ol className="relative space-y-5" data-id="element-78">
        {auditLog.entries.map((entry, i) => {
        const isSystem = entry.actor === 'System';
        const isLast = i === auditLog.entries.length - 1;
        return <li key={entry.id} className="relative flex gap-3" data-id="element-79">
              {!isLast && <span aria-hidden className="absolute left-[15px] top-8 h-[calc(100%+4px)] w-px bg-slate-200 dark:bg-[#333]" data-id="element-80" />}
              <span className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${isSystem ? 'border-slate-200 dark:border-[#333] bg-slate-100 dark:bg-[#2a2a2a] text-slate-500 dark:text-[#a3a3a3]' : 'border-blue-100 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-300'}`} data-id="element-81">
                {isSystem ? <Cpu size={14} data-id="element-82" /> : <User size={14} data-id="element-83" />}
              </span>
              <div className="min-w-0 flex-1 pb-1" data-id="element-84">
                <p className="text-sm text-slate-900 dark:text-[#e5e5e5]" data-id="element-85">
                  <span className="font-medium" data-id="element-86">{entry.actor}</span>{' '}
                  {entry.action}
                </p>
                <p className="mt-0.5 truncate text-xs text-slate-500 dark:text-[#a3a3a3]" data-id="element-87">
                  {entry.target}
                </p>
                <p className="mt-0.5 text-[10px] uppercase tracking-wide text-slate-400 dark:text-[#555]" data-id="element-88">
                  {entry.time}
                </p>
              </div>
            </li>;
      })}
      </ol>
    </SlideOver>;
}